@import "../../helpers/helpers";

.list {
  background: #eee;
  flex-grow: 1;
  border-radius: 0.25em;
  margin-top: 8px;
  max-width: 100%;
  padding: 1em;
}

.add {
  color: transparent;
  width: 100%;
  border: none;
  border-radius: 5px;
  margin-top: 10px;
  height: 40px;
  cursor: pointer;
}

.item {
  margin: 30px 0 30px;
  position: relative;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.itemBody {
  padding: 0 0 12px;
  line-height: 1.25;

  a {
    color: blue;
  }
}

.timestamp {
  color: #ccc;
  font-size: 1em;
}

.remove {
  opacity: 0;
  padding: 6px;
  position: absolute;
  top: 0;
  right: -6px;
  cursor: pointer;
  user-select: none;
  pointer-events: none;
  border: none;

  .item:hover & {
    opacity: 1;
    pointer-events: initial;
  }
}
